<template>
  <div class="pure-layout-wrap">
    <!-- 如果在webview端，那么在进入时，就应该隐藏头部 -->
    <!-- 如果在mobile端，使用移动端的适配样式 -->
    <!-- @TODO 如果是在app中则不展示 -->
    <div class="header" v-show="showHeader">
      <DownloadApp v-if="showDownloadApp" />
      <client-only>
      <NavigatorBar :project="project" />
    </client-only>
    </div>
    <div
      class="main-container"
      :class="[
        $props.containerClass,
        {
          roadmap: navigatorBarConfig.roadmap,
          isApp: isWebview || $$systemInfo.isApp,
        },
        [navigatorBarConfig.theme, navigatorBarConfig.size, { mobileNotApp: showHeader && showDownloadApp }],
      ]"
    >
      <slot />
    </div>
    <ClientCommon />
    <Footer
      :theme="navigatorBarConfig.footerTheme"
      :roadmap="navigatorBarConfig.roadmap"
      v-show="!(isWebview || $$systemInfo.isApp || hideFooter)"
    />
    <!-- <CountryBlock /> -->
    <!-- <VerificationLimitDIalog /> -->
    <!-- <KycCountryLimitDialog /> -->
    <!-- <Verify /> -->
    <!-- <MfaVerifyNotice :visible="mfaVerifyNoticeVisible" @update:visible="changeMfaVerifyNoticeVisible" /> -->
    <client-only>
      <DepositGuide />
    </client-only>
    <!-- <client-only>
      <AiChat />
    </client-only> -->
  </div>
</template>

<script lang="ts">
import ClientCommon from '~/components/ClientCommon.vue';
import { isLoginedToken } from '~/common/js/utils';
// import { events } from '~/common/js/track'
import commonMixins from '~/mixins/common';
import Footer from '~/frontend-shared/components/Footer/index.vue';
import NavigatorBar from '~/frontend-shared/components/NavigatorBar';
import DownloadApp from '~/frontend-shared/components/global/DownloadApp.vue';
import {
  NAVIGATOR_BAR_CONFIG_MAP,
  NAVIGATOR_BAR_CONFIG_DEFAULT,
  PROJECT_MAP,
} from '~/frontend-shared/components/NavigatorBar/config';
import { FUTURES_NAVIGATOR_BAR_CONFIG_MAP } from '~/frontend-shared/components/NavigatorBar/futures-config';
import CountryBlock from '~/components/CountryBlock.vue';
import VerificationLimitDIalog from '~/components/global/VerificationLimitDIalog.vue';
import KycCountryLimitDialog from '~/components/global/KycCountryLimitDialog.vue';
import Verify from '~/frontend-shared/components/Verify/index.vue';
import MfaVerifyNotice from '~/components/account/MfaVerifyNotice';
import { mapState, usePatchStore } from '~/common/js/patch';
import DepositGuide from '~/frontend-shared/components/DepositGuide';

import { head } from '~/common/js/baseLayout';
// aiChat
import AiChat from '~/frontend-shared/components/aiChat/index.vue';

export default {
  name: 'MainLayout',
  components: {
    ClientCommon,
    NavigatorBar,
    DownloadApp,
    Footer,
    CountryBlock,
    VerificationLimitDIalog,
    KycCountryLimitDialog,
    Verify,
    MfaVerifyNotice,
    DepositGuide,
    AiChat,
  },
  mixins: [commonMixins],
  props: {
    hideFooter: Boolean,
    containerClass: String,
  },
  data() {
    return {
      project: PROJECT_MAP.MASTER,
      isWebview: false, // 是否是webview 如果是要去掉头部导航和尾部导航
      isShowDownApp: false,
    };
  },
  computed: {
    ...mapState({
      mfaVerifyNoticeVisible: (state) => state.mfaVerifyNoticeVisible,
    }),
    // @TODO 改成用class。get的方式获取某一项
    navigatorBarConfig() {
      const barConfig =
        this.project === PROJECT_MAP.DERIVATIVES
          ? FUTURES_NAVIGATOR_BAR_CONFIG_MAP.get(this.$route.name)
          : NAVIGATOR_BAR_CONFIG_MAP.get(this.$route.name);
      return {
        ...NAVIGATOR_BAR_CONFIG_DEFAULT,
        ...(barConfig || {}),
      };
    },
    showHeader() {
      return !(this.isWebview || this.$$systemInfo.isApp);
    },
    showDownloadApp() {
      return this.$route.name !== 'app-lang' && this.isShowDownApp;
    },
  },
  mounted() {
    
    // 优化头部的展示，通过url上的query，人为判断
    // 兜底措施，万一真的注入延迟有延迟
    this.$nextTick(() => {
      if (window.jsBridge !== undefined) {
        this.isWebview = true;
      }
    });
    this.isWebview = false;
    const launched = +sessionStorage.getItem?.('launched');
    if (isLoginedToken() && !launched) {
      // this.$riskTrack({
      //   event_id: events.APP_LAUNCH,
      // })
      sessionStorage.setItem?.('launched', '1');
    }

    import('amfe-env').then((env) => {
      if (!env.os.isIOS && !env.os.isAndroid) {
        this.isShowDownApp = false;
        return;
      }
      if (window.navigator.userAgent.indexOf('BitMart') >= 0) {
        // 在 Bitmart APP里面
        this.isShowDownApp = false;
      } else {
        this.isShowDownApp = true;
      }
    });
  },
  methods: {
    changeMfaVerifyNoticeVisible() {
      this.commit('HIDE_MFA_VERIFY_NOTICE_VISIBLE');
    },
  },
  setup() {
    const { commit } = usePatchStore();
    useHead(head());
    return {
      commit,
    };
  },
};
</script>

<style lang="less" scoped>
@import '~/common/css/element-base-type.less';
@import '~/common/css/ui.variables.less';
.header {
  position: fixed;
  width: 100vw;
  z-index: 999;
}

.main-container {
  // @TODO 导航条高度的垫高高导航条组件来实现
  // 不限制这里的宽度，具体页面中的自适应式和响应式断点由具体的业务页面自行设置
  // 486高度为底部footer的高度
  min-height: calc(100vh - 134px);
  box-sizing: border-box;
  padding-top: 0;

  // light-transparent和dark-transparent 不需要padding-top
  &:not(.isApp) {
    &.dark,
    &.light {
      padding-top: @navigator_bar_height;
      &.mobileNotApp {
        padding-top: @navigator_bar_height_mobileNotApp;
      }
    }

    &.small {
      &.dark,
      &.light {
        padding-top: @navigator_bar_height_small;
        &.mobileNotApp {
          padding-top: @navigator_bar_height_small_mobileNotApp;
        }
      }
    }
  }

  &.roadmap {
    min-height: calc(100vh - 456px);
  }
}
</style>
